import { useTranslation } from 'react-i18next';

type Partner = {
  name: string;
  logo: string;
  imageClassName?: string;
};

const PARTNERS: Partner[] = [
  { name: 'oneZero Financial', logo: '/img/partners/onezero.png' },
  { name: 'Equiti', logo: '/img/partners/equiti.png' },
  { name: 'LMAX Global', logo: '/img/partners/lmax.png' },
  { name: 'B2Broker', logo: '/img/partners/b2broker.png' },
  {
    name: 'CBCX',
    logo: '/img/partners/cbcx.png',
    imageClassName: 'max-h-[72px] md:max-h-[80px]',
  },
];

export default function PartnersSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-white relative overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-yellow-400/40 to-transparent" />
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[680px] h-[280px] rounded-full bg-yellow-400/5 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-10 md:mb-12">
          <p className="text-sm font-semibold tracking-[0.22em] uppercase text-yellow-600 mb-3">
            {t("home.partners.network", { defaultValue: "JLB Global Network" })}
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('home.partners.title')}
          </h2>
          <p className="max-w-3xl mx-auto text-base md:text-lg text-gray-600 leading-relaxed">
            {t('home.partners.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {PARTNERS.map((partner) => (
            <div
              key={partner.name}
              className="group h-28 md:h-32 rounded-2xl border border-gray-200/90 bg-white shadow-sm flex items-center justify-center px-5 md:px-6 transition-all duration-300 ease-out hover:-translate-y-1 hover:border-yellow-400/50 hover:shadow-xl hover:shadow-yellow-500/10"
              title={partner.name}
              aria-label={partner.name}
            >
              <img
                src={partner.logo}
                alt={`${partner.name} logo`}
                loading="lazy"
                decoding="async"
                className={`max-w-full max-h-14 md:max-h-16 w-auto h-auto object-contain opacity-100 grayscale-0 transition-transform duration-300 ease-out group-hover:scale-[1.06] ${
                  partner.imageClassName || ''
                }`}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
